import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingPopupMinimizedHeaderActionsComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-minimized-header-actions/floating-popup-minimized-header-actions.component';
import { FloatingPopupBaseContentComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-content/floating-popup-base-content.component';
import { FLOATING_POPUP_DATA } from '@app/main/main-content/floating-popup-manager/providers/floating-popup-data.token';
import { FloatingPopupTabsService } from '@app/main/main-content/floating-popup-manager/services/floating-popup-tabs.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { FpCorrelationManagerStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/services/fp-correlation-manager/fp-correlation-manager.store';
import { FpCorrelationManagerActionType } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/services/fp-correlation-manager/fp-correlation-manager.actions';
import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';

@Component({
  selector: 'gc-fp-correlation-minimized-content',
  standalone: true,
  imports: [
    CommonModule,
    FloatingPopupMinimizedHeaderActionsComponent,
    SpinnerComponent,
    FloatingPopupBaseErrorMessageComponent,
  ],
  templateUrl: './fp-correlation-minimized-content.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FpCorrelationMinimizedContentComponent extends FloatingPopupBaseContentComponent {
  public readonly data = inject<IFpCorrelationData>(FLOATING_POPUP_DATA);
  private readonly floatingPopupTabs = inject(FloatingPopupTabsService);
  private readonly floatingPopupCorrelationManagerStore = inject(FpCorrelationManagerStore);

  public activeTabConnectService = toSignal(this.floatingPopupCorrelationManagerStore.activeTabConnectService$, {
    initialValue: null,
  });

  public selectedTab = computed(() => this.floatingPopupTabs.getActive(this.popupId())());

  public loading = toSignal(this.floatingPopupCorrelationManagerStore.loading$, {
    initialValue: false,
  });

  public activeTabLoading = toSignal(this.floatingPopupCorrelationManagerStore.activeTabLoading$, {
    initialValue: false,
  });

  public selectedData = toSignal(this.floatingPopupCorrelationManagerStore.selectedData$, {
    initialValue: null,
  });

  public initialized = toSignal(this.floatingPopupCorrelationManagerStore.initialized$, {
    initialValue: false,
  });

  constructor() {
    super();

    const effectRef = effect(() => {
      const popupId = this.popupId();

      if (popupId) {
        this.initPopupStoreManager(popupId);

        effectRef.destroy();
      }
    });
  }

  private initPopupStoreManager(popupId: string) {
    this.floatingPopupCorrelationManagerStore.dispatch({
      type: FpCorrelationManagerActionType.Init,
      popupId: popupId,
      selectedData: this.data,
      activeTab: this.floatingPopupTabs.getActive(popupId)() as FpCorrelationTabs,
    });
  }
}
